export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12126.e999a158.jpg";